import { apiClient } from '../services/apiClient';
import { ENDPOINTS } from '../constants/endpoints';

export const getAllQuestions = (listeningId, part, questionSetId) =>
  apiClient.get(ENDPOINTS.LISTENING.QUESTIONS(listeningId, part, questionSetId));

export const deleteQuestion = (listeningId, part, questionId) =>
  apiClient.delete(ENDPOINTS.LISTENING.DELETE_QUESTION(listeningId, part, questionId));

export const deleteQuestionSet = (listeningId, part, questionSetId) =>
  apiClient.delete(ENDPOINTS.LISTENING.QUESTION_SET(listeningId, part, questionSetId));

export const getQuestionById = (listeningId, part, questionSetId, questionId) =>
  apiClient.get(ENDPOINTS.LISTENING.QUESTION(listeningId, part, questionSetId, questionId));

export const createQuestion = (listeningId, part, questionSetId, data) =>
  apiClient.post(ENDPOINTS.LISTENING.CREATE_QUESTION(listeningId, part, questionSetId), data);

export const updateQuestion = (listeningId, part, questionSetId, questionId, data) =>
  apiClient.put(ENDPOINTS.LISTENING.UPDATE_QUESTION(listeningId, part, questionSetId, questionId), data);
